import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Divider,
  Paper,
  Grid,
  SwipeableDrawer,
  Typography,
  TextField,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import ToastApp from "../../../ToastApp";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import PrintIcon from "@mui/icons-material/Print";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";
import api from "../../../utils/Url";
import { Label } from "@mui/icons-material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#00009C",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Row({ row, index }: { row: any; index: number }) {

  return (
    <React.Fragment>
      <StyledTableRow sx={{ border: "1px gray solid", padding: "5px" }}>
        <TableCell style={{ border: "1px gray solid" }} align="center">
          {index + 1}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }}>
          {row.fileNumber}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }} align="center">
          {row.fromLocation}
        </TableCell>
        {/* <TableCell style={{ border: "1px gray solid" }}  align="center">
            {row.synopsis}
          </TableCell> */}
        <TableCell style={{ border: "1px gray solid" }} >
          {row.toLocation}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }} align="center">
          {row.refId}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }} align="center">
          {row.senderName}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }} align="center">
          {row.receiverName}
        </TableCell>
      </StyledTableRow>
    </React.Fragment>
  );
}

export default function FileMovementReports() {
  

  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [data, setData] = useState<any>([]);
  const { t } = useTranslation();


  const [optionLocation, setOptionLocation] = useState([
    { value: "-1", label: t("text.SelectFromLocation") },
  ]);

  const [optionMember, setOptionMember] = useState([
    { value: "-1", label: t("text.SelectSenderMember")},
  ]);
  const [optionFileDetailsAll, setOptionFileDetailsAll] = useState([
    { value: "-1", label: t("text.SelectFile") },
  ]);
  const [optionRefid, setOptionRefid] = useState([
    { label: t("text.SelectRFID") },
  ]);
  const [optionDepartment, setOptionDepartment] = useState([
    {value:"-1", label:"Select Department"}
  ])

  useEffect(() => {
    getLocationData();
    getFileTypeData();
    getFileDtailsAllData();
    getDepartmentData();
  }, []);

  const getDepartmentData = () => {
    const collectData = {
      departmentId: -1,
    };

    api
      .post("Department/GetDepartmentmaster", collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["departmentName"],
            value: res.data.data[index]["departmentId"],
          });
        }
        setOptionDepartment(arr);
      });
  };



  const getLocationData = () => {
    const collectData = {
      id: -1,
    };

    api
      .post("LocationItems/GetMappedLocation", collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["location"],
            value: res.data.data[index]["id"],
          });
        }
        setOptionLocation(arr);
      });
  };


  const getFileTypeData = () => {
    const collectData = {
      useR_ID: "-1",
    };
    api.post(`USER/GetUSER`, collectData).then((res) => {
      const arr = res.data.data.map((item: any) => ({
        label: item.firsT_NAME  + " " + item.middlE_NAME + "  "+ item.suR_NAME,
        value: item.useR_ID,
      }));
        setOptionMember(arr);
      });
  };

  const getFileDtailsAllData = () => {
    const collectData =
    {
      "fileID": -1,
      "chackNo": "",
      "fileType": -1,
      "fileGroup": -1,
      "fileCategory": -1,
      "fileClass": -1,
      "fileSubject": -1,
      "show": true,
      "exportOption": "string"
    }

    api
      .post( "FileDetail/GetFileDetails", collectData)
      .then((res) => {
        const arr = [];
        const arr1: any = [];

        console.log("result" + JSON.stringify(res.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label:res.data.data[index]["fileNo"]  + " - " + res.data.data[index]["fileName"]  ,
            value: res.data.data[index]["fileID"],
          });
        }

        for (let index = 0; index < res.data.data.length; index++) {
          const rfid = res.data.data[index]["rfid"];
          const refID = res.data.data[index]["fileID"];

          // Check if rfid is not empty or zero
          if (rfid !== "" && rfid !== 0) {
            arr1.push({
              label: rfid,
              value: refID,
            });
          }
        }
        setOptionRefid(arr1);
        console.log("arr1", arr1);
        setOptionFileDetailsAll(arr);
      });
  };

  const handleFilterButtonClick = () => {
    setFilterDrawerOpen(true);
    console.log("value handleFilterButtonClick", filterDrawerOpen);
  };

  const handleCloseDrawer = () => {
    setFilterDrawerOpen(false);
  };

  interface FormValues {
    fileID: any;
    fileNumber: any;
    hid:any;
    fromLocation: any;
    toLocation: any;
    refId: any;
    sender: any;
    receiver: any;
  }

  const initialValues: FormValues = {
    "hid": -1,
  "fileID": 0,
  "fileNumber": "",
  "fromLocation": "",
  "toLocation": "",
  "refId": 0,
  "sender": "",
  "receiver": ""
  };

  const formik = useFormik({
    initialValues: initialValues,

    onSubmit: async (values) => {
      // console.log("Form values:", formik.values);

      if (values.fileID === initialValues.fileID) {
        values.fileID = -1;
      }
      if (values.fileNumber === initialValues.fileNumber) {
        values.fileNumber = "";
      }
      if (values.fromLocation === initialValues.fromLocation) {
        values.fromLocation = "";
      }
      if (values.toLocation === initialValues.toLocation) {
        values.toLocation = "";
      }
      if (values.refId === initialValues.refId) {
        values.refId = -1;
      }
      if (values.sender === initialValues.sender) {
        values.sender = "";
      }
      if (values.receiver === initialValues.receiver) {
        values.receiver = "";
      }
     

      console.log("check data before submitting", values);

      const response = await api.post(
        `FileMovementHistory/GetFileMovementHistoryFilter`,
        values
      );
      setData(response.data.data);
      handleCloseDrawer();
      if (response.data.isSuccess) {
        toast.success(response.data.mesg);
      } else {
        toast.error(response.data.mesg);
      }
    },
  });

  const handlePrint = () => {
    const contentElement = document.getElementById("tabcont");
    if (contentElement) {
      const clonedContent = contentElement.cloneNode(true) as HTMLElement;

      const filterButton = clonedContent.querySelector(".filter-button");
      if (filterButton) {
        filterButton.remove();
      }
      const printButton = clonedContent.querySelector(".print-button");
      if (printButton) {
        printButton.remove();
      }

      const printWindow = window.open("", "_blank");
      if (printWindow) {
        printWindow.document.body.appendChild(clonedContent);

        printWindow.print();
      } else {
        console.error("Error: Unable to open print window.");
      }
    }
  };

  return (
    <Card
      style={{
        width: "100%",
        backgroundColor: "#E9FDEE",
        border: ".5px solid #fff ",
        marginTop: "3vh",
      }}
    >
      <Paper
        sx={{
          width: "100%",
          overflow: "hidden",
          "& .MuiDataGrid-colCell": {
            backgroundColor: "#f0ad4e",
            color: "#000",
            fontSize: 17,
            fontWeight: 900,
          },
        }}
        style={{ padding: "10px" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
           {t("text.FileMovementReport")}
          </Typography>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 20,
            }}
          >
            <Button
              type="button"
              onClick={() => handleFilterButtonClick()}
              style={{
                backgroundColor: "blue",
                fontSize: "15px",
                color: "#fff",
                textTransform: "none",
                cursor: "pointer",
              }}
            >
              <FilterAltIcon />
              {t("text.Filter")}
            </Button>
            <Button
              type="button"
              onClick={handlePrint}
              style={{
                backgroundColor: "blue",
                fontSize: "15px",
                color: "#fff",
                textTransform: "none",
                cursor: "pointer",
              }}
            >
              <PrintIcon />
              {t("text.Print")}
            </Button>
            <iframe
              id="ifmcontentstoprint"
              style={{ height: "0px", width: "0px", position: "absolute" }}
            ></iframe>
          </div>
          <SwipeableDrawer
            anchor="right"
            open={filterDrawerOpen}
            onClose={handleCloseDrawer}
            onOpen={() => {}}
            slotProps={{
              backdrop: {
                style: { backgroundColor: "rgba(0, 0, 0, 0.7)" },
              },
            }}
            PaperProps={{
              style: {
                width: 310,
                boxShadow: "0px 0px 8px 0px rgba(0,0,0,0.2)",
              },
            }}
            style={{
              zIndex: 1300,
            }}
          >
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{
                margin: "20px 0px",
              }}
              align="center"
            >
               {t("text.FileMovementReport")}
            </Typography>
            <Divider />

            <div style={{ margin: "20px 0px" }}>
              <form onSubmit={formik.handleSubmit}>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    marginLeft: "0px",
                  }}
                >

<Grid xs={11} sm={11} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={optionFileDetailsAll}
                      fullWidth
                      size="small"
                      onChange={(event, newValue) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("fileID", newValue?.value);
                        formik.setFieldTouched("fileID", true);
                        formik.setFieldTouched("fileID", false);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("text.SelectFile")} />
                      )}
                    />
                  </Grid>

                  <Grid xs={11} sm={11} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={optionRefid}
                      fullWidth
                      size="small"
                      onChange={(event, newValue:any) => {
                        console.log(newValue);
                        // fileID
                        formik.setFieldValue("fileID", newValue?.value);
                        //formik.setFieldTouched("refId", true);
                        //formik.setFieldTouched("refId", false);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("text.SelectRFID")} />
                      )}
                    />
                  </Grid>

                   <Grid xs={11} sm={11} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={optionMember}
                      fullWidth
                      size="small"
                      onChange={(event, newValue) => {
                        console.log(newValue?.value);
                        formik.setFieldValue("sender", newValue?.value);
                        formik.setFieldTouched("sender", true);
                        formik.setFieldTouched("sender", false);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("text.SelectSenderMember")} />
                      )}
                    />
                  </Grid>

                  <Grid xs={11} sm={11} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={optionMember}
                      fullWidth
                      size="small"
                      onChange={(event, newValue) => {
                        console.log(newValue?.value);
                        formik.setFieldValue("receiver", newValue?.value);
                        formik.setFieldTouched("receiver", true);
                        formik.setFieldTouched("receiver", false);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("text.SelectReceiverMember")} />
                      )}
                    />
                  </Grid> 

                  <Grid xs={11} sm={11} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={optionLocation}
                      fullWidth
                      size="small"
                      onChange={(event, newValue) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("fromLocation", newValue?.label?.toString());
                        formik.setFieldTouched("fromLocation", true);
                        formik.setFieldTouched("fromLocation", false);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("text.SelectFromLocation")} />
                      )}
                    />
                  </Grid>

                  <Grid xs={11} sm={11} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={optionDepartment}
                      fullWidth
                      size="small"
                      onChange={(event, newValue) => {
                        console.log(newValue?.value);

                        formik.setFieldValue("toLocation", newValue?.label?.toString());
                        formik.setFieldTouched("toLocation", true);
                        formik.setFieldTouched("toLocation", false);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("text.SelectToLocation")} />
                      )}
                    />
                  </Grid>

                  <Grid xs={10} item>
                    <div style={{ justifyContent: "space-between", flex: 1 }}>
                      <Button
                        type="submit"
                        variant="contained"
                        style={{
                          width: "37%",
                          // backgroundColor: "#059669",
                          margin: "0.5%",
                        }}
                      >
                       {t("text.search")}
                      </Button>
                      <Button
                        type="reset"
                        variant="contained"
                        style={{
                          width: "37%",
                          // backgroundColor: "#F43F5E",
                          margin: "0.5%",
                        }}
                        onClick={() => {
                          formik.resetForm();

                        }}
                      >
                        {t("text.Clear")}
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </form>
            </div>
          </SwipeableDrawer>
        </div>

        <Divider />
        <br />

        <TableContainer
          component={Paper}
          id="tabcont"
          sx={{
            maxHeight: "65vh",
            marginBottom: "10px",
            border: "1px solid #fff",
          }}
        >
          <Table
            aria-label="customized  table"
            style={{
              border: "1px gray solid",
              borderCollapse: "collapse",
              width: "100%",
            }}
          >
            <TableHead
               style={{
                border: "1px gray solid",
                borderCollapse: "collapse",
                position: "sticky",
                top: 0, 
                zIndex: 1, 
                backgroundColor: "#fff",
              }}
            >
              <StyledTableCell
                colSpan={10}
                align="center"
                style={{
                  fontSize: 17,
                  fontWeight: 600,
                  border: "1px gray solid",
                  padding: "5px",
                  backgroundColor: "transparent",
                  color: "#000",
                }}
              >
                 {t("text.FileMovementReport")}
              </StyledTableCell>
              <TableRow>
                {/* <StyledTableCell /> */}
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                  {t("text.SrNo")}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                  {t("text.FileNo")}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                  {t("text.FromLocation")}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                  {t("text.ToLocation")}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                 {t("text.RFID")}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                  {t("text.Sender")}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    border: "1px gray solid",
                    padding: "10px",
                  }}
                >
                  {t("text.Receiver")}
                </StyledTableCell>
              </TableRow>
            </TableHead>
           {data && <TableBody>
              {data.map((row: any, index: any) => (
                <Row key={row.any} row={row} index={index} />
              ))}
            </TableBody>}
          </Table>
        </TableContainer>
      </Paper>
    </Card>
  );
}
